import { scaleLinear } from "d3";

function getTick(x, scale) {
  return {
    tick: x,
    label: x,
    helpText: String(x),
    color: "#7774",
    y: scale(x),
  };
}

function getCoverageTicks(max) {
  const scale = scaleLinear().domain([max, 0]).range([0, 1]);
  return scale.ticks(5).map((x) => getTick(x, scale));
}

export default getCoverageTicks;
